import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { fmtDateTime } from "@/lib/constants";
import { Wand2 } from "lucide-react";

function Body({ suggestion, onCancel, onApply }) {
  if (suggestion.loading) return <p className="text-sm text-slate-400 py-4 text-center">Analysing free capacity…</p>;
  const d = suggestion.data;
  if (!d) return null;
  if (d.strategy === "none") return <p className="text-sm text-slate-600 py-2">{d.message}</p>;
  return (
    <div className="space-y-3">
      <div className="rounded-lg border border-emerald-200 bg-emerald-50/60 p-4">
        <p className="text-sm font-semibold text-emerald-800" data-testid="suggestion-message">{d.message}</p>
        <div className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-xs text-slate-600">
          <span className="text-slate-400">Line</span><span className="font-mono-data font-semibold">{d.line_name || "Unassigned"}</span>
          <span className="text-slate-400">New start</span><span className="font-mono-data font-semibold">{fmtDateTime(d.start_date)}</span>
          <span className="text-slate-400">Est. duration</span><span className="font-mono-data font-semibold">{d.estimated_hours}h</span>
          <span className="text-slate-400">Est. completion</span><span className="font-mono-data font-semibold">{fmtDateTime(d.estimated_completion)}</span>
        </div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onCancel}>Cancel</Button>
        <Button className="bg-emerald-600 hover:bg-emerald-700" onClick={onApply} data-testid="apply-suggestion-button">Apply Reschedule</Button>
      </DialogFooter>
    </div>
  );
}

// Conflict auto-reschedule suggestion. suggestion = { order, data, loading } | null
export default function SuggestionDialog({ suggestion, onClose, onApply }) {
  return (
    <Dialog open={!!suggestion} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="suggestion-modal">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2"><Wand2 className="h-4 w-4 text-amber-600" /> Reschedule Suggestion — {suggestion?.order?.order_code}</DialogTitle>
          <DialogDescription>{suggestion?.order?.conflict_reason}</DialogDescription>
        </DialogHeader>
        {suggestion && <Body suggestion={suggestion} onCancel={onClose} onApply={onApply} />}
      </DialogContent>
    </Dialog>
  );
}
